<template>

    <b-container fluid style="width: 90%; margin-top: 30px">
        <b-container fluid>
            <b-row class="border border-dark" style="background-color: darkgray" cols="2">
                <b-col cols="2" :style="this.executionProgress"></b-col>
                <b-col v-for="item in metricsList" cols="2"
                       class="border border-right-0 border-dark border-top-0 border-bottom-0">
                    {{ item.year }}
                </b-col>
            </b-row>
            <b-row class="border border-dark border-top-0">
                <b-col cols="2">Grid electricity kWh/case</b-col>
                <b-col v-for="item in metricsList" cols="2"
                       class="border border-right-0 border-dark border-top-0 border-bottom-0">
                    {{ item.totalGridElecPerCase.toFixed(1) }}
                </b-col>
            </b-row>
            <b-row class="border border-dark border-top-0" style="background-color: lightgray">
                <b-col cols="2">Solar electricity kWh/case</b-col>
                <b-col v-for="item in metricsList" cols="2"
                       class="border border-right-0 border-dark border-top-0 border-bottom-0">
                    {{ item.totalSolarElecPerCase.toFixed(1) }}
                </b-col>
            </b-row>
            <b-row class="border border-dark border-top-0">
                <b-col cols="2">TOTAL electricity kWh/case</b-col>
                <b-col v-for="item in metricsList" cols="2"
                       class="border border-right-0 border-dark border-top-0 border-bottom-0">
                    {{ item.totalElecPerCase.toFixed(1) }}
                </b-col>
            </b-row>
            <b-row class="border border-dark border-top-0" style="background-color: lightgray">
                <b-col cols="2">Gallons of water/gallon of wine (process/tasting/offices)</b-col>
                <b-col v-for="item in metricsList" cols="2"
                       class="border border-right-0 border-dark border-top-0 border-bottom-0">
                    {{ item.galsWaterToWineOffice.toFixed(1) }}
                </b-col>
            </b-row>
            <b-row class="border border-dark border-top-0">
                <b-col cols="2">Gallons landscape water/gallon of wine</b-col>
                <b-col v-for="item in metricsList" cols="2"
                       class="border border-right-0 border-dark border-top-0 border-bottom-0">
                    {{ item.galsWaterToWineLandscape.toFixed(1) }}
                </b-col>
            </b-row>
            <b-row class="border border-dark border-top-0" style="background-color: lightgray">
                <b-col cols="2">TOTAL water/gallon of wine</b-col>
                <b-col v-for="item in metricsList" cols="2"
                       class="border border-right-0 border-dark border-top-0 border-bottom-0">
                    {{ item.totalGalsWaterToWine.toFixed(1) }}
                </b-col>
            </b-row>
            <b-row style="margin: 20px">

            </b-row>
            <b-row style="margin-top: 20px;">
                <b-col cols="3">
                </b-col>
                <b-col cols="3">
                    <router-link to="/resource-graphs" tag="button"
                                 style="color: white; background-color: green; height: 40px; width: 200px">Resource
                        Graphs
                    </router-link>
                </b-col>
                <b-col cols="3">
                    <router-link to="/metrics-tabbed" tag="button"
                                 style="color: white; background-color: green; height: 40px; width: 200px">Metrics
                        Calculator
                    </router-link>
                </b-col>
                <b-col cols="3">
                </b-col>
            </b-row>
        </b-container>
    </b-container>
</template>

<script>
import MetricsSummaryBlock from "./MetricsSummaryBlock";

export default {
  name: "MetricsSummaryPage",
  components: {MetricsSummaryBlock},
  executionProgress: {
    background: 'linear-gradient(to right, rgba(0, 255, 0, 0.2) 0% , rgba(0, 255, 0, 0.2) 55.00%, rgba(0, 255, 0, 0.0) 57.00%) no-repeat'
  },
  props: {
    groupId: String
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "TabbedMetrics" && Object.keys(to.params).length === 0) {
                next({name: "TabbedMetrics", params: {groupId: this.theGroupId}})
            } else if (to.name === "Resource Graphs" && Object.keys(to.params).length === 0) {
                next({name: "Resource Graphs", params: {groupId: this.theGroupId}})
            } else {
                next()
            }

        },
        data() {
            return {
                metricsList: [{
                    totalGridElectricity: 0,
                    totalSolarElectricity: 0,
                    officeWater: 0,
                    landscapeWater: 0,
                    brandWineProduced: 0,
                    customCrushProduced: 0,
                    bulkWineShipped: 0,
                    totalGalsWine: 0,
                    equivTotalCasesWine: 0,
                    totalGridElecPerCase: 0,
                    totalSolarElecPerCase: 0,
                    totalElecPerCase: 0,
                    galsWaterToWineOffice: 0,
                    galsWaterToWineLandscape: 0,
                    totalGalsWaterToWine: 0
                },
                    {
                        totalGridElectricity: 0,
                        totalSolarElectricity: 0,
                        officeWater: 0,
                        landscapeWater: 0,
                        brandWineProduced: 0,
                        customCrushProduced: 0,
                        bulkWineShipped: 0,
                        totalGalsWine: 0,
                        equivTotalCasesWine: 0,
                        totalGridElecPerCase: 0,
                        totalSolarElecPerCase: 0,
                        totalElecPerCase: 0,
                        galsWaterToWineOffice: 0,
                        galsWaterToWineLandscape: 0,
                        totalGalsWaterToWine: 0
                    }
                    , {
                        totalGridElectricity: 0,
                        totalSolarElectricity: 0,
                        officeWater: 0,
                        landscapeWater: 0,
                        brandWineProduced: 0,
                        customCrushProduced: 0,
                        bulkWineShipped: 0,
                        totalGalsWine: 0,
                        equivTotalCasesWine: 0,
                        totalGridElecPerCase: 0,
                        totalSolarElecPerCase: 0,
                        totalElecPerCase: 0,
                        galsWaterToWineOffice: 0,
                        galsWaterToWineLandscape: 0,
                        totalGalsWaterToWine: 0
                    },
                    {
                        totalGridElectricity: 0,
                        totalSolarElectricity: 0,
                        officeWater: 0,
                        landscapeWater: 0,
                        brandWineProduced: 0,
                        customCrushProduced: 0,
                        bulkWineShipped: 0,
                        totalGalsWine: 0,
                        equivTotalCasesWine: 0,
                        totalGridElecPerCase: 0,
                        totalSolarElecPerCase: 0,
                        totalElecPerCase: 0,
                        galsWaterToWineOffice: 0,
                        galsWaterToWineLandscape: 0,
                        totalGalsWaterToWine: 0
                    }],
                theGroupId: this.groupId || localStorage.getItem('adminImpersonationGroupId') || localStorage.getItem('groupId')
            }
        },
        mounted() {
            //let groupId = localStorage.getItem("groupId");
            //console.log("[" + groupId + "]");
            this.$http.get("metrics/summary/" + this.theGroupId)
                .then(result => {
                    this.metricsList = result.data;
                    console.log(this.metricsList);
                    console.log("=========================");
                    console.log(this.transpose(this.metricsList));

                })
                .catch(err => console.log("Error: " + err));
        },
        methods: {
            transpose: function (a) {
                return Object.keys(a[0]).map(function (c) {
                    return a.map(function (r) {
                        return r[c];
                    });
                });
            }
        }
    }
</script>

<style>
    .div#col2 {
        border: 1px solid black;
    }

</style>
